module.exports = __webpack_public_path__ + "img/img41.492e95d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img41.jpg
// module id = 340
// module chunks = 0